import { render } from "./FicheClinique.vue?vue&type=template&id=46e523f6&scoped=true"
import script from "./FicheClinique.vue?vue&type=script&lang=js"
export * from "./FicheClinique.vue?vue&type=script&lang=js"

import "./FicheClinique.vue?vue&type=style&index=0&id=46e523f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e523f6"]])

export default __exports__